import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import moment from 'moment';

class SketchADayPage extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <section className="sketch-a-day-page container">
                <Helmet>
                    <title>Sketch A Day | Ailsa Lyn Artist</title>
                    <meta name="description" content="Sketch a day." />
                    {this.props.sketch &&
                        <meta property="og:title" content={"Sketch a day for " + moment(this.props.sketch.date).format("dddd Do MMM 'YY")} />
                    }
                    {this.props.sketch &&
                        <meta property="og:description" content={this.props.sketch.description} />
                    }
                    {this.props.sketch &&
                        <meta property="og:image" content={this.props.sketch.imageLargeUrl} />
                    }
                </Helmet>
                {this.props.sketch &&
                    <div>
                        <div className="row sketch-head">
                            <div className="col-2 text-left change-sketch">
                                {this.props.previousUrl &&
                                    <Link to={this.props.previousUrl} title="Previous sketch" >
                                        <i className="fa fa-arrow-circle-o-left" aria-hidden="true" />
                                    </Link>
                                }
                            </div>
                            <div className="col">
                                <h1 className="text-center">{moment(this.props.sketch.date).format("dddd Do MMM 'YY")}</h1>
                            </div>
                            <div className="col-2 text-right change-sketch">
                                {this.props.nextUrl &&
                                    <Link to={this.props.nextUrl} title="Next sketch">
                                        <i className="fa fa-arrow-circle-o-right" aria-hidden="true" />
                                    </Link>
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 text-center">
                                <img className="img-fluid" src={this.props.sketch.imageLargeUrl} />
                            </div>
                            {this.props.sketch.description &&
                                <p className="col-12">{this.props.sketch.description}</p>
                            }
                        </div>
                    </div>
                }
            </section>
        );
    }
}

SketchADayPage.propTypes = {
    sketch: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    nextUrl: PropTypes.string,
    previousUrl: PropTypes.string
};

function mapStateToProps(state, ownProps) {
    const date = ownProps.match.params.date;

    let sketches = state.sketchADays
        .filter(sketch => sketch.date < new Date())
        .sort((sketch1, sketch2) => sketch2.date - sketch1.date);

    let sketch = null, nextUrl, previousUrl;

    if (sketches.length > 0) {
        let index = getIndexOfSketch(sketches, date);
        sketch = sketches[index];

        nextUrl = buildUrl(sketches, index - 1);
        previousUrl = buildUrl(sketches, index + 1);
    }

    return {
        loading: state.ajaxCallsInProgress > 0,
        sketch,
        nextUrl,
        previousUrl,
    };
}

function getIndexOfSketch(sketches, dateString) {
    let index = 0;

    if (dateString && dateString.split("-").length === 3) {
        const split = dateString.split("-");
        const year = Number(split[0]),
            month = Number(split[1]),
            day = Number(split[2]);

        const sketch = sketches.filter((s) => {
            return (
                s.date.getFullYear() === year
                && s.date.getMonth() === month - 1
                && s.date.getDate() === day
            );
        });
        if (sketch.length === 1) {
            index = sketches.indexOf(sketch[0]);
        }
    }
    return index;
}

function buildUrl(sketches, index) {
    const sketch = sketches[index];
    let url;
    if (sketch) {
        url = "/sketch-a-day/" + moment(sketch.date).format("YYYY-MM-DD");
    }
    return url;


}

export default connect(
    mapStateToProps
)(SketchADayPage);



// WEBPACK FOOTER //
// ./src/components/sketchADay/SketchADayPage.js